import { jsx, Fragment } from 'react/jsx-runtime';
import { Tooltip } from '../Tooltip/Tooltip.es.js';

const ButtonTooltip = ({ iconOnly, label, variant, children })=>{
    if (!iconOnly) {
        return jsx(Fragment, {
            children: children
        });
    }
    // Make sure label prop exists for icon only buttons or throw
    if (label == null) {
        throw new Error('You must pass the label prop for icon only buttons');
    }
    return jsx(Tooltip, {
        className: "z-40",
        closeEvents: [
            'click',
            'mouseleave'
        ],
        content: label,
        onDark: variant === 'inverted',
        place: "bottom",
        size: "sm",
        width: "hug",
        children: children
    });
};
ButtonTooltip.displayName = 'ButtonTooltip';

export { ButtonTooltip as default };
//# sourceMappingURL=Button.Tooltip.es.js.map
